import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;

@Component({
  selector: "app-experience-task",
  templateUrl: "./experience-task.component.html",
  styleUrls: ["./experience-task.component.css"],
})
export class ExperienceTaskComponent implements OnInit {
  public list: Array<any> = [];
  public imagePath: any;
  public pageData: object = {};
  public page = { pageNumber: 1 };

  constructor(private http: HttpService, private router: Router) {}

  ngOnInit() {
    this.getList();
    this.getPath();
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      console.log(res.data);
    });
  }

  public getList(isSearch = false) {
    let data = { ...this.page };
    data.pageNumber--;
    this.http.getData(API.experienceTaskPage, data).then((res) => {
      this.list = res.data.content;
      this.pageData = res.data;
      delete this.pageData["content"];
    });
  }

  public edit(id) {
    this.router.navigate(["/index/experiencetask", id]);
  }

  public del(id) {
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      () => {
        this.http.deleteData(API.experienceTask + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            this.getList();
          } else {
            alertify.error(res.status.message);
          }
        });
        console.log(id);
      },
      () => {}
    );
  }

  public pageChange(e: any) {
    this.page = e;
    this.getList();
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/experience-task/experience-task.component.ts